import { useClassifierServiceGetCommonClassifierElementListEndpoint } from 'src/api/queries'
import { DEFAULT_ONE_HUNDRED_PER_PAGE } from 'src/app-constants'

/** All elements of a small classifier (the fișa classifiers have fewer than 100 elements). */
export const useClassifierElements = (classifierId?: string) => {
  const { data, isLoading } =
    useClassifierServiceGetCommonClassifierElementListEndpoint(
      {
        id: String(classifierId),
        pageNumber: 1,
        pageSize: DEFAULT_ONE_HUNDRED_PER_PAGE
      },
      [classifierId, 'all'],
      { enabled: !!classifierId, staleTime: 1000 * 60 * 5 }
    )

  const elements = data?.data ?? []

  const findIdByKey = (key: string) =>
    elements.find((element) => element.originalValue === key)?.id

  return { elements, isLoading, findIdByKey }
}
